import { computed, type ComputedRef, type Ref, unref } from 'vue'
import { useTitle } from '@vueuse/core'

export function usePageTitle(name: string | Ref<string>): ComputedRef<string> {
  const pageTitle = computed(() => `Crowdy | ${unref(name)}`)

  useTitle(pageTitle)

  return pageTitle
}
